import { Controller } from "@hotwired/stimulus"
import Fuse from "fuse.js"

export default class extends Controller {
  static targets = ["input", "hidden", "dropdown", "clear"]
  static values = { vendors: Array }

  connect() {
    this.fuse = new Fuse(this.vendorsValue, {
      keys: ["name", "no"],
      threshold: 0.3,
      minMatchCharLength: 1
    })

    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }

  search() {
    const query = this.inputTarget.value.trim()
    this.hiddenTarget.value = ""
    this.clearTarget.hidden = true

    if (query.length === 0) {
      this.closeDropdown()
      return
    }

    const results = this.fuse.search(query).slice(0, 10)
    this.renderDropdown(results.map(r => r.item))
  }

  select(event) {
    const id = event.currentTarget.dataset.vendorId
    const name = event.currentTarget.dataset.vendorName
    const no = event.currentTarget.dataset.vendorNo

    this.hiddenTarget.value = id
    this.inputTarget.value = `${no} — ${name}`
    this.clearTarget.hidden = false
    this.closeDropdown()
  }

  clear() {
    this.hiddenTarget.value = ""
    this.inputTarget.value = ""
    this.clearTarget.hidden = true
    this.inputTarget.focus()
  }

  renderDropdown(vendors) {
    this.dropdownTarget.innerHTML = ""

    if (vendors.length === 0) {
      this.dropdownTarget.innerHTML = '<div class="vendor-search-empty">No vendors found</div>'
      this.dropdownTarget.hidden = false
      return
    }

    vendors.forEach(vendor => {
      const item = document.createElement("button")
      item.type = "button"
      item.className = "vendor-search-item"
      item.dataset.vendorId = vendor.id
      item.dataset.vendorName = vendor.name
      item.dataset.vendorNo = vendor.no
      item.dataset.action = "click->vendor-search#select"
      item.innerHTML = `<span class="vendor-search-no">${vendor.no}</span> ${vendor.name}`
      this.dropdownTarget.appendChild(item)
    })

    this.dropdownTarget.hidden = false
  }

  closeDropdown() {
    this.dropdownTarget.hidden = true
    this.dropdownTarget.innerHTML = ""
  }

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.closeDropdown()
    }
  }
}
